/**
 * Verifica se um valor é nulo ou indefinido.
 */
export const isNullOrUndefined = (value) => {
  return value === null || value === undefined;
};

/**
 * Verifica se é nulo, indefinido ou um array vazio.
 */
export const isNullOrUndefinedOrEmptyArray = (value) => {
  return isNullOrUndefined(value) || value.length === 0;
};

/**
 * Verifica se é nulo, indefinido ou um objeto vazio ({}).
 */
export const isNullOrUndefinedOrEmptyObject = (value) => {
  return isNullOrUndefined(value) || Object.keys(value).length === 0;
};

/**
 * Verifica se é nulo, indefinido, não é string ou é uma string vazia/apenas espaços.
 */
export const isNullOrUndefinedOrEmptyString = (value) => {
  // prettier-ignore
  // eslint-disable-next-line max-len
  return isNullOrUndefined(value) || typeof value !== "string" || value.trim() === "";
};
